import { __extends, __decorate } from 'tslib';
import { MagicConfigMixin } from '@gig/magic-common';
import { Component, Mixins } from 'vue-property-decorator';

var SweepstakesVerificationProgress = /** @class */ (function (_super) {
    __extends(SweepstakesVerificationProgress, _super);
    function SweepstakesVerificationProgress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SweepstakesVerificationProgress = __decorate([
        Component({
            name: 'sweepstakes-verification-progress',
        })
    ], SweepstakesVerificationProgress);
    return SweepstakesVerificationProgress;
}(Mixins(MagicConfigMixin)));

export default SweepstakesVerificationProgress;
